import React, { ReactNode } from 'react';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { HttpStatusError } from '../support/useFetch';

const MAX_RETRIES = 3;

export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      networkMode: 'always',
      refetchOnWindowFocus: false,
      retry: (failureCount, error) => {
        // Don't retry on HTTP 400, 404, etc
        if (error instanceof HttpStatusError) {
          return false;
        }
        return failureCount < MAX_RETRIES;
      },
    },
  },
});

type Props = {
  children: ReactNode;
};

export function QueryProvider({ children }: Props) {
  return (
    <QueryClientProvider client={queryClient}>{children}</QueryClientProvider>
  );
}
